module.exports = __webpack_public_path__ + "media/images/online_zoom-2cf5d67433bbbf4bee15cf5c8b85d6e7.svg";